import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { useStaticQuery, graphql } from "gatsby"
import styles from "./pagestyles/index.module.scss"
import NewsScroll from "../components/newsScroll"
import BlockContentWrapper from "../components/blockContent"
import ImageCarousel from "../components/ImageCarousel"

const IndexPage = (data) => {
  const articles = data.pageContext.articles || []

  const {
    sanityLandingPage: { mainImageGallery, _rawBody, _rawStatement },
  } = useStaticQuery(graphql`
    query {
      sanityLandingPage(_id: { regex: "/landingPage$/" }) {
        _rawBody(resolveReferences: { maxDepth: 10 })
        mainImageGallery {
          ...ImageWithPreview
        }
        _rawStatement
      }
    }
  `)

  const statement = _rawStatement.map((item) =>
    item.children.map((child) => child.text)
  )

  return (
    <Layout noPadding transparentPos={200} isHomePage={true}>
      <SEO title="Velkommen" description={statement} />
      <header>
        <ImageCarousel statement={statement} images={mainImageGallery} />
      </header>
      <section className={styles.newsSection}>
        <NewsScroll articles={articles} />
      </section>
      <section className={styles.content}>
        <BlockContentWrapper blocks={_rawBody} />
      </section>
    </Layout>
  )
}

export default IndexPage
